export default __webpack_public_path__ + "static/media/m33.443af3fc.png";